var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66699C9.92016 6.66699 9.80558 6.68088 9.70488 6.69477C9.88891 7.01421 10 7.38227 10 7.7781C10 9.00553 9.00523 10.0003 7.7778 10.0003C7.38196 10.0003 6.98266 9.88574 6.69099 9.70519C6.68058 9.80935 6.66669 9.91699 6.66669 10.0003C6.66669 11.8094 8.15974 13.3337 10 13.3337C11.8403 13.3337 13.3334 11.841 13.3334 10.0007C13.3334 8.1604 11.809 6.66699 10 6.66699Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.22266C14.2674 2.22266 17.9965 5.12196 19.8785 9.37891C19.9444 9.56293 20 9.82682 20 10.0004C20 10.1428 19.9444 10.4379 19.8785 10.622C17.9965 14.8761 14.2674 17.7782 10 17.7782C5.73264 17.7782 2.00417 14.8789 0.120451 10.5918C0.0542361 10.4379 0 10.1732 0 10.0004C0 9.82682 0.0542708 9.56293 0.120451 9.37891C2.00312 5.12543 5.73264 2.22266 10 2.22266ZM10.0035 15.0004C12.7615 15.0004 15 12.7591 15 10.0004C15 7.24002 12.7604 5.00043 10 5.00043C7.23958 5.00043 5 7.24002 5 10.0004C5 12.7609 7.24306 15.0004 10.0035 15.0004Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5e4a210da8ce1315b02c25aa178587d0.svg";
export { ForwardRef as ReactComponent };